import React from 'react';

export const BETFINDER_PORTAL_ID = 'betfinder-portal';

const BetfinderPortal = () => <div id={BETFINDER_PORTAL_ID}></div>;

export default BetfinderPortal;
